import { render, staticRenderFns } from "./DeliveryProviders.vue?vue&type=template&id=43232c58"
import script from "./DeliveryProviders.vue?vue&type=script&lang=js"
export * from "./DeliveryProviders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports